import { ChevronRight } from 'lucide-react'
import { FaDiscord } from 'react-icons/fa'

export const DISCORD_INVITE_URL = 'https://discord.gg/pAHC44he4z'

type JoinDiscordSectionVariant = 'challenge' | 'proving-grounds'

type JoinDiscordSectionProps = {
  variant: JoinDiscordSectionVariant
}

function DiscordMark({ className }: { className?: string }) {
  return <FaDiscord aria-hidden="true" className={className} />
}

export function JoinDiscordSection({ variant }: JoinDiscordSectionProps) {
  if (variant === 'proving-grounds') {
    return (
      <div className="signup-discord">
        <div className="signup-discord-copy">
          <DiscordMark />
          <div>
            <h4>Join Discord</h4>
            <p>Join the BondTrader community on Discord.</p>
          </div>
        </div>
        <a
          className="signup-discord-cta"
          href={DISCORD_INVITE_URL}
          rel="noreferrer"
          target="_blank"
        >
          Join Discord
        </a>
      </div>
    )
  }

  return (
    <a
      href={DISCORD_INVITE_URL}
      rel="noreferrer"
      target="_blank"
      className="flex items-center gap-3 rounded-[10px] border border-[#1d2f39] bg-[#0a1218] p-4 text-[#edf3f1] no-underline transition-colors hover:border-[#2a4150]"
    >
      <DiscordMark className="size-6 shrink-0 text-[#5865f2]" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold leading-tight">Join Discord</p>
        <p className="mt-0.5 text-sm leading-relaxed text-[#93a5ac]">
          Required to complete your challenge setup.
        </p>
      </div>
      <ChevronRight className="size-4 shrink-0" aria-hidden="true" />
    </a>
  )
}
